// eslint-disable-next-line
export const LOCALSTORAGE_IDS = {
  USER_COOKIES: 'qwello-cookies',
  CHANGE_COUNTRY_POPUP: 'popup',
};

export const FALLBACK_META_DESCRIPTION =
  'Leaving the complex behind and making space for effortless E-mobility.';
export const FALLBACK_DOCUMENT_TITLE = 'laadpaal aanvragen | Qwello';
